var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal-dialog',{attrs:{"modal-visible":_vm.visible,"title":"Select a Template","submit-visible":false,"modal-size":"modal-lg"},on:{"closeModal":function($event){return _vm.$emit('closeModal')}}},[_c('field',{staticClass:"mb-2",attrs:{"params":{
				type: 'btn-group',
				buttons: [
					{text: 'Search',icon:'fa-search',value:'search'},
					{text: 'Browse',icon:'fa-tags',value:'browse'}
			]}},model:{value:(_vm.findType),callback:function ($$v) {_vm.findType=$$v},expression:"findType"}}),_c('categorized-list-record-selector',{attrs:{"is-customer-asset-template":true,"type":_vm.findType},on:{"select":_vm.selectTemplate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }